import './index.less';

import EmbeddingModelSelector from './EmbeddingModelSelector';
import LLMModelSelector from './LLMModelSelector';

type ModelSelectorSubComponents = {
  LLM: typeof LLMModelSelector;
  Embedding: typeof EmbeddingModelSelector;
};

const ModelSelector: ModelSelectorSubComponents = () => null;

ModelSelector.LLM = LLMModelSelector;
ModelSelector.Embedding = EmbeddingModelSelector;

export default ModelSelector;
